import React, { useEffect, useState } from "react";
import useViewport from "components/UseViewport/UseViewport";
import MemberInfo from "containers/AboutUs/Members/MemberInfo/MemberInfo/MemberInfo";
import { Col, Divider, Row, Space, Typography } from "antd";
import axios from "axios";
import { BLgroupMember } from "interfaces/internal";
import { ActiveMember } from "interfaces/activeMember";
import MemberInfoMobile from "./MemberInfo/MemberInfoMobile/MemberInfoMobile";

const { Title } = Typography;

const Members = () => {
  const [kdMembers, setKDMembers] = useState<BLgroupMember[]>([]);
  const [members, setMembers] = useState<ActiveMember[]>([]);
  const { width } = useViewport();
  const breakpoint = 992;

  useEffect(() => {
    axios.get<BLgroupMember[]>("/internal/6/group-members/").then(response => {
      setKDMembers(response.data);
    });
  }, []);

  useEffect(() => {
    axios.get<ActiveMember[]>(`/internal/active-members/`).then(response => {
      // Only select members that are in the KD group, and sort them by position
      setMembers(
        response.data
          .filter(member => kdMembers.some(kdMember => kdMember.bl_member === member.id))
          .sort((a, b) => {
            const positionA = kdMembers.find(kdMember => kdMember.bl_member === a.id)?.position ?? "";
            const positionB = kdMembers.find(kdMember => kdMember.bl_member === b.id)?.position ?? "";

            if (positionA.toLowerCase() === "leder") {
              return -1;
            }
            if (positionB.toLowerCase() === "leder") {
              return 1;
            }
            if (positionA.toLowerCase() === "nestleder") {
              return -1;
            }
            if (positionB.toLowerCase() === "nestleder") {
              return 1;
            }
            return positionA.localeCompare(positionB);
          })
      );
    });
  }, [kdMembers]);

  // Display all active group leaders in Bindeleddet
  const displayActiveKdMembers = members.map(member => {
    if (!member.show_on_bl_page) return null;
    return (
      <Col key={member.id}>
        {width < breakpoint ? (
          <MemberInfoMobile
            BlMemberImage={member.profile_picture}
            BlMemberName={member.full_name}
            BlMemberRole={kdMembers.find(kdMember => kdMember.bl_member === member.id)?.position ?? "Medlem"}
            BlMemberTelephone={member.mobile}
            BlMemberEmail={member.bl_email}
          />
        ) : (
          <MemberInfo
            BlMemberImage={member.profile_picture}
            BlMemberName={member.full_name}
            BlMemberRole={kdMembers.find(kdMember => kdMember.bl_member === member.id)?.position ?? "Medlem"}
            BlMemberTelephone={member.mobile}
            BlMemberEmail={member.bl_email}
          />
        )}
      </Col>
    );
  });

  return (
    <>
      <Space direction="horizontal" style={{ width: "100%", justifyContent: "center" }}>
        <Title>Medlemmer</Title>
      </Space>
      <Divider />

      <Row>
        <Col span={24}>
          <Row style={width < breakpoint ? { justifyContent: "center" } : { justifyContent: "left" }}>
            <Title level={3}>Teamet bak KarriereDagene NTNU</Title>
            <br />
            <br />
          </Row>

          <Row gutter={[25, 30]} style={width < breakpoint ? { justifyContent: "center" } : { justifyContent: "left" }}>
            {displayActiveKdMembers}
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default Members;
